"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedItems = exports.reducer = void 0;
const react_1 = require("react");
var Action;
(function (Action) {
    Action["SELECT_ALL"] = "SELECT_ALL";
    Action["CLEAR_ALL"] = "CLEAR_ALL";
    Action["SELECT_ONE"] = "SELECT_ONE";
    Action["CLEAR_ONE"] = "CLEAR_ONE";
})(Action || (Action = {}));
function getSelectedShapeFromArray(items) {
    return items.reduce((acc, item) => Object.assign(acc, { [item]: true }), {});
}
function reducer(state = {}, action) {
    switch (action.type) {
        case Action.SELECT_ALL: {
            return getSelectedShapeFromArray(action.items);
        }
        case Action.CLEAR_ALL: {
            return {};
        }
        case Action.SELECT_ONE: {
            return Object.assign(Object.assign({}, state), { [action.value]: true });
        }
        case Action.CLEAR_ONE: {
            const _a = state, _b = action.value, value = _a[_b], newState = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return newState;
        }
        default:
            return state;
    }
}
exports.reducer = reducer;
function useSelectedItems(items = [], initialSelectedItems = []) {
    const [selectedItems, dispatch] = (0, react_1.useReducer)(reducer, getSelectedShapeFromArray(initialSelectedItems));
    const hasSelectedAll = (0, react_1.useMemo)(() => items.length > 0 &&
        items.every(item => selectedItems.hasOwnProperty(item)), //eslint-disable-line
    [selectedItems, items]);
    const onToggleAllItems = (0, react_1.useCallback)(() => {
        if (hasSelectedAll) {
            dispatch({ type: Action.CLEAR_ALL });
        }
        else {
            dispatch({ type: Action.SELECT_ALL, items });
        }
    }, [dispatch, hasSelectedAll, items]);
    const onToggleOneItem = (0, react_1.useCallback)((item) => {
        //eslint-disable-next-line
        if (selectedItems.hasOwnProperty(item)) {
            dispatch({ type: Action.CLEAR_ONE, value: item });
        }
        else {
            dispatch({ type: Action.SELECT_ONE, value: item });
        }
    }, [dispatch, selectedItems]);
    const reset = (0, react_1.useCallback)(() => {
        dispatch({ type: Action.CLEAR_ALL });
    }, [dispatch]);
    return {
        selectedItems,
        hasSelectedAll,
        onToggleAllItems,
        onToggleOneItem,
        reset,
        selectedItemsArray: Object.keys(selectedItems)
    };
}
exports.useSelectedItems = useSelectedItems;
